module.exports = __webpack_public_path__ + "static/media/browser-deluxe-enviro.eb4845cc.png";